export default __webpack_public_path__ + "static/media/hover-imatge-escoltant@2x.748d9d96.jpg";